import './BetbookPostDetailHeader.less';

import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useReframe } from 'nike-re-framejs';
import i18n from '@i18n';

import { BackButton, LeftIconButton } from '@/common/components/HelperButtons';
import { useSticky } from '@/_hooks/useSticky';
import { animate } from '@/common/animate';
import BetbookPostReactions from '@/betbook/components/betbook-reactions/BetbookPostReactions';
import { accountNickname$ } from '@/account/subs';
import { comments$ } from '@/betbook/subs';

function BetbookPostDetailHeader({ postType, post, commentsCount }) {
    const { pick, viewCount } = post;
    const [isSticky, stickyRef] = useSticky();
    const { subscribe } = useReframe();
    const currentUserNickName = subscribe(accountNickname$);
    const comments = subscribe(comments$);
    const currentUserComment =
        comments && Object.values(comments.byId).some(element => element.nickname === currentUserNickName);
    const sportId = pick?.sportId;

    const [currentUserOwnComment, setUserOwnComment] = useState(currentUserComment);

    useEffect(() => {
        setUserOwnComment(currentUserComment);
    }, [currentUserComment]);

    const cancelRef = useRef();

    function scrollToStake() {
        const cancel = cancelRef.current;
        if (cancel) {
            cancel();
        }
        const accordion = document.getElementsByClassName('accordion')[0];
        const header = document.getElementsByClassName('betbook-header')[0];
        if (accordion && accordion.getBoundingClientRect) {
            const scrollStart = window.pageYOffset;
            const scrollEnd = accordion.offsetTop - header.getBoundingClientRect().height - 20;
            cancelRef.current = animate(scrollStart, scrollEnd, 250, value => window.scroll(0, value));
        }
    }

    return (
        <>
            <div className={clsx('betbook-header', `bg-${sportId}`, { fixed: isSticky })} ref={stickyRef}>
                <div className="betbook-header-info">
                    <div className="betbook-header-back-button">
                        <BackButton className="" button={<LeftIconButton />} isBetbook />
                    </div>
                    <div className="betbook-header-title">
                        <div>
                            <div>{i18n('betbook.detail.' + postType)}</div>
                        </div>
                    </div>
                </div>
                <div className="betbook-header-reactions">
                    <BetbookPostReactions
                        isInDetail
                        className="detail"
                        postType={postType}
                        commentsCount={commentsCount}
                        onCommentClick={scrollToStake}
                        customerComment={currentUserOwnComment}
                        viewCount={viewCount}
                    />
                </div>
            </div>
            {isSticky ? <div className="betbook-post-header-sticky-placeholder" /> : null}
        </>
    );
}

export default BetbookPostDetailHeader;
